/**
 *  @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-10-19 15:03:20
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-10-11 17:26:45
 * @FilePath: /wemeet-web-activity/src/pages/event/[eventid]/registration/buyer/controller/getServerProps.ts
 * @Description: 获取报名页服务端数据
 */

import { GetServerSidePropsContext } from 'next';
import ActivitiesPublicRegistrationPage, {
  Data as RegistrationData,
} from '@quickService/ActivitiesPublicRegistrationPage';
import PublicRegistrationQueryEventSchedulers, {
  Data as ScheduleData,
  SchedulerDataList,
} from '@quickService/PublicRegistrationQueryEventSchedulers';
import { HostDetailRes } from '@model/host-account';
import { OwnSchedules } from '@quickService/ActivitiesRegisterQueryUserSchedule';
import PublicCouponQueryPublicList from '@quickService/PublicCouponQueryPublicList';
import { isWechat, isAndroid } from '@tencent/web-base';
import { getCanvasData } from '@model/register-canvas';
import { CouponsExtend } from '@model/buyer-coupon';
import cookies from 'next-cookies';
import GetWechatMpAuthURL from 'src/model/GetWechatMpAuthURL';
import GetWechatOpenid from 'src/model/GetWechatOpenid';
import { isMobileServer } from '@utils/ua/is-mobile';
import getRainbowConfig from '@utils/rainbow/index';
import isShowNewRegistration from '@utils/registrationGray';
export enum TicketType {
  NONE,
  PACKAGE,
  SINGLE,
}

export interface ServerProps {
  scheduleId?: string;
  registrationData: RegistrationData;
  scheduleData: ScheduleData;
  activityLabels: Array<{ text: string; undeletable: boolean }>;
  actTime: string;
  eventid: string;
  myScheduleList: OwnSchedules;
  hostData?: HostDetailRes['data'];
  selectScheduleId: string;
  setSelectScheduleId?: any;
  showScheduleList: SchedulerDataList;
  anchorTabs: any;
  price: string;
  changeNavTab: any;
  pageData?: any;
  dates?: any;
  setCurr: any;
  curr: number;
  isCanvas: boolean;
  canvasData?: any;
  couponList?: CouponsExtend;
  wxopenId?: string;
  isMobile?: boolean;
  couponName?: string;
}

const getWxOPenId = async (ctx: GetServerSidePropsContext, ua: string) => {
  // 获取微信openId从服务器上获取吧
  // 判断是否微信
  const { wx, nh } = ctx.query;
  const iswx = wx === '1' || isWechat(ua);
  const userCookies = cookies(ctx);
  const webWxOpenidKey = 'web_wxopenid';
  let wxopenId = String(userCookies[webWxOpenidKey] || '');

  // 未登录的不做处理，或者是直播内购买不做处理
  if (!userCookies.app_uid || nh === '1') {
    return {};
  }

  if (wxopenId && wxopenId !== '' && wxopenId !== 'undefined') {
    return {
      wxopenId,
    };
  }

  // 获取微信登录链接并且登录
  const redirectToGetState = async () => {
    const result = await GetWechatMpAuthURL(
      {
        redirect_uri: `https://${ctx.req.headers.host}/events/host/${ctx.resolvedUrl}` || '',
      },
      ctx,
    );

    // @ts-ignore
    if (result?.code === 0) {
      // 重定向到获取微信openid页面
      return {
        redirect: {
          // @ts-ignore
          destination: result.data.we_chat_auth_url,
          permanent: false,
        },
      };
    }

    return null;
  };

  if (iswx) {
    const { code, state } = ctx.query;

    if (code && state) {
      const res = await GetWechatOpenid(
        {
          code,
          state,
        },
        ctx,
      );

      if (res.code === 0) {
        wxopenId = res.data.openid;
        ctx.res.setHeader('Set-Cookie', [`${webWxOpenidKey}=${wxopenId}; secure; HttpOnly`]);
      } else if (res?.code === -20017 || res?.code === -20013) {
        // 获取失败的话，重新获取
        ctx.res.setHeader('Set-Cookie', [`${webWxOpenidKey}=; secure; HttpOnly; Max-Age=0`]);

        const data = await redirectToGetState();

        if (data) {
          return data;
        }
      }
    } else {
      const data = await redirectToGetState();

      if (data) {
        return data;
      }
    }
  }

  return {
    wxopenId,
    iswx,
  };
};

// 服务端数据获取
export default async (ctx: GetServerSidePropsContext) => {
  const { eventid }: any = ctx.params;
  const { s_id: sId, wxmode, b, sm, ispreview, temp } = ctx.query;
  let ua = ctx.req.headers['user-agent'] || '';
  ua = ua.toLocaleLowerCase();
  const tempToken = temp ? (temp as string) : '';
  let source: 0 | 1 | 2 | undefined = 0;
  if (ispreview === '1' && !tempToken) source = 1;
  if (tempToken) source = 2;
  // 非微信的安卓内会有查看会议时候会带上这些东西，然后就自动拉起会议吧
  if (!isWechat(ua) && isAndroid(ua) && wxmode === '1' && b) {
    return {
      redirect: {
        // @ts-ignore
        destination: `https://${ctx.req.headers.host}/events/host/app-launch?${decodeURIComponent(
          b as string,
        )}${sm ? `${decodeURIComponent(sm as string)}` : ''}`,
        permanent: false,
      },
    };
  }

  const pageData = await Promise.all([
    ActivitiesPublicRegistrationPage(
      {
        event_id: eventid,
        cos_image_type: 'origin',
        source,
        temp_token: tempToken,
      },
      ctx,
    ),
    PublicRegistrationQueryEventSchedulers(
      {
        event_id: eventid,
        guest_image_type: 'origin',
        scheduler_pic_image_type: 'origin',
        source,
        temp_token: tempToken,
      },
      ctx,
    ),
    PublicCouponQueryPublicList(
      {
        event_id: eventid,
      },
      ctx,
    ),
    getCanvasData(eventid, source !== 0, source, tempToken, ctx)
      .then((data) => {
        const { isCanvas, schema, packages } = data;
        return {
          isCanvas,
          canvasData: schema ? { schema, packages } : null,
        };
      })
      .catch(() =>
        Promise.resolve({
          isCanvas: false,
        }),
      ),
    getRainbowConfig(ctx),
  ]);

  let activityLabels: any = [];
  const registrationData = pageData?.[0]?.data || '';
  const scheduleData = pageData?.[1]?.data || '';
  const couponList = pageData?.[2]?.data?.coupons || '';
  const couponName = pageData?.[2]?.data?.name || '';
  const labels = pageData?.[0]?.data?.activity_basic_info?.labels;
  if (labels && labels.length > 0) {
    activityLabels = labels.map((item) => ({
      text: item,
      undeletable: true,
    }));
  }

  // TypeError: Cannot destructure property 'max_price' of 'registrationData.activity_basic_info' as it is undefined
  const { max_price: maxPrice, show_price: price } = registrationData.activity_basic_info || {};
  /** 当前报名页灰度 */
  const grayData = pageData?.[4];
  const hostId = String(registrationData?.activity_basic_info?.host_id) || '';
  const isShowNew = isShowNewRegistration(grayData, hostId);
  if (isShowNew)
    return {
      redirect: {
        destination: `https://${ctx.req.headers.host}${ctx.resolvedUrl.replace(
          '/event/',
          '/events/',
        )}`,
        permanent: false,
      },
    };
  let wxData: any;
  // 如果是免费的就不请求这个了
  if (!(registrationData.event_enroll_status === 0 || !price || maxPrice === 0)) {
    wxData = await getWxOPenId(ctx, ua);
    if (wxData?.redirect) {
      return wxData;
    }
  }

  return {
    props: {
      scheduleId: sId || '',
      registrationData,
      scheduleData,
      activityLabels,
      eventid,
      couponList,
      pageData: pageData?.[0]?.data && pageData?.[1].data ? '' : pageData,
      ...pageData[3],
      ...wxData,
      isMobile: isMobileServer(ua),
      couponName,
      isShowNew,
    },
  };
};
